import { ParametrosEmpresa } from "./request-servicio";

export class Multidestino {
  idCliente: number;
  idPasajero:number;
  idPromoActivacion: string;
  pasajero: string;
  numeroContacto: string;
  emailPasajero:string
  kilometros: number;
  tarifa: number;
  Referencia:  string;
  txtShowMarker: boolean;
  marker: any;
  ID:Number
    index: number;
    indexLetra : string
    direccion: string;
    direccionGeocode: string;
    latllng: google.maps.LatLng;
    estado: boolean;
    showReferencia: boolean;
    Instruccion:string ='';
    IdServicio:number
    IdDestino:number
    overviewPolyline:string
    parametrosEmpresa: ParametrosEmpresa;
    ajusteTarifa:number
    KilometrosSinAjuste:number
    tiempoViajeSinAjuste:number
    constructor() {
        this.txtShowMarker = false;
        this.showReferencia = false;
        this.IdServicio=0
        this.IdDestino=0
        this.overviewPolyline=""
    }
}
